/*TODO: 古いスクリプトはissue #1433で削除予定 */
/* https://github.com/doctorbook/academy2/issues/1433 */
/* 絞り込み検索 */
/* TODO(#1463): keyword を一本化したあと、PC/SP 二重送信対策が必要なら learning.js を見直す */
/* https://github.com/doctorbook/academy2/issues/1463 */
$(function(){
    /* PC用 */
    if (window.matchMedia("(min-width: 668px)").matches) {
        // 簡易絞込を開閉する
        $("#search_program_form .search_movie_box_tag dt").on("click", function(e) {
            e.stopPropagation();
            $(this).next().slideToggle(300);
            $(this).toggleClass("active");
        });
    }
    /* スマホ用 */
    else {
        //SPのみ要素の位置変更
        $(".search_movie").prependTo(".learning_main");
        // 詳細絞込
        $(function() {
            var scrollPos;
            // 詳細絞込モーダルを開く
            $("#search_program_form .search_movie_box_btn_more").on("click", function() {
                scrollPos = $(window).scrollTop();
                $("html").addClass("is_fixed");
                $(".search_movie_detail_wrap").fadeToggle(300);
                $(this).toggleClass("active");
            });
            // 詳細絞込モーダルを閉じる
            $("#search_program_form .search_movie_detail_btn_close").click(function () {
                $("html").removeClass("is_fixed");
                $(".search_movie_detail_wrap").fadeOut();
                $(".search_movie_box_btn_more").removeClass("active");
                $(window).scrollTop(scrollPos);
            });
        });
    }

    /* PC/スマホ共通 */
    // チェックボックスがチェックされた時
    $('#search_program_form input[type="checkbox"]').on('click', function(){
        // チェックボックスのチェック状態の同期をとる
        var name = $(this).attr('id');
        if (name.indexOf('_simple_sp') !== -1) {
            name = name.replace('_simple_sp', '');
        }
        if (name.indexOf('_simple') !== -1) {
            name = name.replace('_simple', '');
        }
        $('#' + name).prop('checked', $(this).prop('checked'));
        $('#' + name + '_simple').prop('checked', $(this).prop('checked'));
        $('#' + name + '_simple_sp').prop('checked', $(this).prop('checked'));
    });
    // すべてをクリアするをクリックした時
    $('#search_program_form .search_movie_box_allclear, #search_program_form .search_movie_detail_btn_clear').on('click', function(e){
        e.preventDefault();
        $('#keyword_pc, #keyword_sp').val('');
        $('input[type="checkbox"]:checked').prop('checked', false);
    });
});

/* プログラム動画一覧 受講状況 SPのみ要素の位置変更 */
$(function(){
    if (window.matchMedia("(max-width: 667px)").matches) {
        $(".learning_progress").prependTo(".learning_main");
    }
});

/* プログラム動画一覧 説明文開閉 */
$(window).on("load", function () {
    var itemHeights = [];
    var returnHeight;

    $(function(){
      $(".learning_program_description_toggle").each(function(){
        var thisHeight = $(this).height();
        itemHeights.push(thisHeight);
        $(this).addClass("is-hide");
        returnHeight = $(this).height();
      });
    });

    $(".learning_program_description_btn").click(function(){
      if(!$(this).hasClass("is-show")) {
        var index = $(this).index(".learning_program_description_btn");
        var addHeight = itemHeights[index] + 35;
        $(this).addClass("is-show").next().animate({height: addHeight},500).removeClass("is-hide");
      } else {
        $(this).removeClass("is-show").next().animate({height: returnHeight},500).addClass("is-hide");
      }
    });
});

/**
 * <dialog> showModal 時に背面スクロールを止め、スクロールバー消失によるレイアウトずれを防ぐ。
 * 開く前の body の overflow / paddingRight（インライン）を保存し、閉じたあと復元する。
 * 二重に開いた場合は参照カウントで、最後が閉じるまでロックを維持する。
 */
let bodyScrollLockDepth = 0;
let savedBodyOverflow = "";
let savedBodyPaddingRight = "";

function acquireBodyScrollLock() {
  if (bodyScrollLockDepth === 0) {
    savedBodyOverflow = document.body.style.overflow;
    savedBodyPaddingRight = document.body.style.paddingRight;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }
  bodyScrollLockDepth += 1;
}

function releaseBodyScrollLock() {
  if (bodyScrollLockDepth === 0) return;
  bodyScrollLockDepth -= 1;
  if (bodyScrollLockDepth === 0) {
    document.body.style.overflow = savedBodyOverflow;
    document.body.style.paddingRight = savedBodyPaddingRight;
  }
}

/**
 * 検索ポップアップコンポーネント
 * <dialog>要素を使用した職種・分野・条件選択ポップアップの制御
 * PC / タブレット: 中央ポップアップ（幅・高さはビューポート内に収める） / SP: ボトムシート（スライドアニメーション付き）
 * 参考: app/javascript/scripts/front/ad_modal.js
 */
document.addEventListener("DOMContentLoaded", () => {
  const popups = document.querySelectorAll("dialog.search-popup");
  if (!popups.length) return;

  // ポップアップをマップで管理（type -> dialog）
  const popupMap = new Map();
  popups.forEach((popup) => {
    const type = popup.dataset.searchPopupType;
    if (type) popupMap.set(type, popup);
  });

  // 選択された値を保持
  const selectedValues = {
    occupation: [],
    field: [],
    condition: { keyword: "", levels: [], learning_statuses: [] }
  };

  // 職種・分野ポップアップから選択済みの data-value を取得
  const selectedValuesFromPopup = (popup) => {
    const selected = popup.querySelectorAll(".search-popup-option--selected");
    return [...selected].map((el) => el.dataset.value).filter(Boolean);
  };

  // 条件ポップアップからキーワード・難易度・学習状況を取得
  const conditionValuesFromPopup = (popup) => {
    const selected = popup.querySelectorAll(".search-popup-option--selected");
    const levels = [];
    const statuses = [];
    selected.forEach((el) => {
      const v = el.dataset.value;
      if (el.dataset.filterType === "level") levels.push(v);
      if (el.dataset.filterType === "learning_status") statuses.push(v);
    });
    return {
      keyword: popup.querySelector(".search-popup__keyword-input")?.value?.trim() ?? "",
      levels,
      learning_statuses: statuses
    };
  };

  /** トリガー要素に選択結果を反映（ラベルを書き込み、--selected をトグル） */
  const syncTriggersWithSelection = (popupType, selectedLabels) => {
    const trigger = document.querySelector(`[data-search-popup-trigger="${popupType}"]`);
    if (!trigger) return;

    const labelsEl = trigger.querySelector(".program-search-box__select-labels");
    if (labelsEl) labelsEl.textContent = selectedLabels.join("、");
    trigger.classList.toggle("program-search-box__select--selected", selectedLabels.length > 0);
  };

  // サーバーが描画した選択状態を selectedValues に復元
  const restoreSelectionsFromDOM = () => {
    popupMap.forEach((popup, type) => {
      if (type === "condition") {
        selectedValues.condition = conditionValuesFromPopup(popup);
      } else {
        selectedValues[type] = selectedValuesFromPopup(popup);
      }
    });
  };
  restoreSelectionsFromDOM();

  const spMediaQuery = window.matchMedia("(max-width: 667px)");
  const openPopup = (popup) => {
    acquireBodyScrollLock();
    popup.showModal();
  };
  const closePopup = (popup) => {
    if (spMediaQuery.matches) {
      popup.classList.add("search-popup--closing");
      popup.addEventListener("animationend", () => {
        popup.classList.remove("search-popup--closing");
        popup.close();
      }, { once: true });
    } else {
      popup.close();
    }
  };

  // --- トリガー要素のクリックでポップアップを開く ---
  document.querySelectorAll("[data-search-popup-trigger]").forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const popup = popupMap.get(trigger.dataset.searchPopupTrigger);
      if (popup) openPopup(popup);
    });
  });

  // --- 各ポップアップにイベントを設定 ---
  popups.forEach((popup) => {
    const type = popup.dataset.searchPopupType;
    popup.addEventListener("close", releaseBodyScrollLock);

    // 閉じるボタン
    popup.querySelector(".search-popup__close")?.addEventListener("click", () => {
      closePopup(popup);
    });

    // backdrop（背景）クリックで閉じる
    popup.addEventListener("click", (e) => {
      if (e.target === popup) closePopup(popup);
    });

    // 選択肢のトグル
    popup.querySelectorAll(".search-popup-option").forEach((option) => {
      option.addEventListener("click", () => {
        option.classList.toggle("search-popup-option--selected");
      });
    });

    // 決定ボタン
    popup.querySelector(".search-popup__submit")?.addEventListener("click", () => {
      const selectedOptions = popup.querySelectorAll(".search-popup-option--selected");
      const selectedLabels = [];

      switch (type) {
        case "condition": {
          const keywordEl = popup.querySelector(".search-popup__keyword-input");
          const keyword = keywordEl?.value?.trim() ?? "";
          selectedValues.condition.keyword = keyword;
          if (keyword) selectedLabels.push(keyword);

          const buckets = { level: [], learning_status: [] };
          selectedOptions.forEach((option) => {
            const label = option.querySelector(".search-popup-option__label")?.textContent;
            if (label) selectedLabels.push(label);
            const value = option.dataset.value;
            const filterType = option.dataset.filterType;
            if (value !== undefined && buckets[filterType]) {
              buckets[filterType].push(value);
            }
          });
          selectedValues.condition.levels = buckets.level;
          selectedValues.condition.learning_statuses = buckets.learning_status;
          break;
        }
        case "occupation":
        case "field": {
          const values = [];
          selectedOptions.forEach((option) => {
            const label = option.querySelector(".search-popup-option__label")?.textContent;
            if (label) selectedLabels.push(label);
            const value = option.dataset.value;
            if (value !== undefined) values.push(value);
          });
          selectedValues[type] = values;
          break;
        }
      }

      syncTriggersWithSelection(type, selectedLabels);
      closePopup(popup);
    });
  });

  // --- 検索ボタンのクリックイベント ---
  document.querySelectorAll("[data-search-submit]").forEach((button) => {
    button.addEventListener("click", () => {
      const baseUrl = button.dataset.searchUrl || "/programs/search";

      const params = new URLSearchParams();

      selectedValues.occupation.forEach((id) => {
        params.append("search_program[tag_ids][]", id);
      });
      selectedValues.field.forEach((id) => {
        params.append("search_program[category_ids][]", id);
      });
      selectedValues.condition.levels.forEach((level) => {
        params.append("search_program[levels][]", level);
      });
      selectedValues.condition.learning_statuses.forEach((status) => {
        params.append("search_program[learning_statuses][]", status);
      });
      // TODO(#1463): keyword 統一後は params 名を search_program[keyword] のみに整理
      params.append("search_program[keyword]", selectedValues.condition.keyword ?? "");

      const queryString = params.toString();
      window.location.href = queryString ? `${baseUrl}?${queryString}` : baseUrl;
    });
  });
});

// --- 動画一覧ポップアップの開閉 ---
document.addEventListener("DOMContentLoaded", () => {
  const movieListPopups = document.querySelectorAll("dialog.movie-list-popup");
  if (!movieListPopups.length) return;

  const movieListPopupMap = new Map();
  movieListPopups.forEach((popup) => {
    const programId = popup.dataset.programId;
    if (programId) movieListPopupMap.set(programId, popup);
  });

  const spMediaQuery = window.matchMedia("(max-width: 667px)");

  const openMovieListPopup = (popup) => {
    acquireBodyScrollLock();
    popup.showModal();
  };

  const closeMovieListPopup = (popup) => {
    if (spMediaQuery.matches) {
      popup.classList.add("movie-list-popup--closing");
      popup.addEventListener("animationend", () => {
        popup.classList.remove("movie-list-popup--closing");
        popup.close();
      }, { once: true });
    } else {
      popup.close();
    }
  };

  document.querySelectorAll("[data-movie-list-popup-trigger]").forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      const popup = movieListPopupMap.get(trigger.dataset.movieListPopupTrigger);
      if (popup) openMovieListPopup(popup);
    });
  });

  movieListPopups.forEach((popup) => {
    popup.addEventListener("close", releaseBodyScrollLock);
    popup.querySelector(".movie-list-popup__close")?.addEventListener("click", () => {
      closeMovieListPopup(popup);
    });
    popup.addEventListener("click", (e) => {
      if (e.target === popup) closeMovieListPopup(popup);
    });
  });
});
